import ApiHeaderKey from "core/constants/api-header-key";
import BaseAppGatewayService from "../base-api-gateway.service";
import { UserActivityLogger } from "../user-tracking-helper";

class BaseCefCommercialService extends BaseAppGatewayService {
    userTracking: UserActivityLogger;

    constructor(trackingArea: string, abortController: AbortController | null = null) {
        super(abortController);

        this.userTracking = new UserActivityLogger(trackingArea);
    }

    protected getRequestHeaders() {
        const headers = super.getRequestHeaders();
        headers[ApiHeaderKey.businessUnit] = "DStv";
        return headers;
    }

    validateCustomerNumber() {
        if (!this.customerNumber) {
            console.error("API Error: Customer Number not found");
        }
    }
}

export default BaseCefCommercialService;
